import PropTypes from "prop-types";
import React from "react";
import { StyleSheet, View, TouchableOpacity } from "react-native";
import Text from "app/components/Text";
import apiActions from "app/utils/apiActions";
import textHelpers from "app/utils/textHelpers";
import { styleSheet, colors, sizes } from "app/utils/styleSheet";
// import { navigationRef } from 'app/utils/RootNavigation';
import * as RootNavigation from "app/utils/RootNavigation.js";

import Value from "app/components/Value";
import TimelineEvent from "app/components/TimelineEvent";
import { Ionicons, Entypo } from "@expo/vector-icons";

export default class Timeline extends React.Component {
  static propTypes = {
    value: PropTypes.object.isRequired,
    itemStyle: PropTypes.any,
    deleteDoneAt: PropTypes.func,
    expandNotes: PropTypes.bool,
    wrapperStyle: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.state = {
      showQuickActions: false,
    };
  }

  render() {
    let { value, itemStyle, deleteDoneAt, expandNotes, wrapperStyle } =
      this.props;

    return (
      <View style={[styles.wrapper, wrapperStyle]}>
        {this.renderValueNote()}

        {textHelpers
          .newestFirst(value.timeline, "timestamp")
          .map((event, i) => {
            // condense duplicates
            let nextEvent = value.timeline[i + 1];
            if (
              nextEvent &&
              nextEvent.timestamp == event.timestamp &&
              nextEvent.type == event.type &&
              event.type == "progress" &&
              nextEvent.text == event.text
            ) {
              nextEvent.count = (event.count || 1) + 1;
              return null;
            }
            return event;
          })
          .filter((e) => e != null) // remove nulls
          .map((event, i) => {
            return (
              <TimelineEvent
                key={i}
                event={event}
                value={value}
                style={itemStyle}
                parentId={value.id}
                handleDelete={deleteDoneAt}
                expandNote={expandNotes}
                allValues={this.props.allValues}
              />
            );
          })}
      </View>
    );
  }

  renderValueNote = () => {
    let { value, itemStyle, deleteDoneAt, expandNotes, wrapperStyle } =
      this.props;

    // if value has not been completed, show the value-level note here
    if (!value.completed_at) {
      let valueNote = value.notes?.find(
        (n) => typeof n == "string" && n?.startsWith("7:")
      );
      if (!!valueNote) {
        return (
          <TimelineEvent
            noteOnly
            event={{ note: valueNote }}
            expandNote={expandNotes}
          />
        );
      }
    }
    return null;
  };
}

const styles = StyleSheet.create({
  wrapper: {
    // marginTop: 20,
    marginLeft: 20,
    alignSelf: "stretch",
    alignItems: "stretch",
    zIndex: -1,
    // flex: 1,
    minWidth: 200,
    paddingBottom: 20,
    // borderColor: 'cyan', borderWidth: 1,
  },
});
